<template>
    <ul class=menu :class="linkCountClass">

        <li v-for="(link, index) in sortedLinks" :key="index" :class="link.slug">

            <template v-if="linkHasChildren( link )">

                <div class=submenu :ref="link.id" v-on:click.self="showSubmenu">
                    <img v-if="link.acf.menu_image" :src="link.acf.menu_image">

                    <InternalMenu :links="link.children"></InternalMenu>
                </div>

            </template>

            <template v-else>

                <router-link :to="'/' + link.path">

                    <img v-if="link.acf.menu_image" :src="link.acf.menu_image">

                    <span>{{ link.title.rendered }}</span>

                </router-link>

            </template>

        </li>

    </ul>
</template>
<script>
import InternalMenu from './InternalMenu.vue'

export default {
    name : 'InternalMenu',
    props : {
        links : Object,
    },
    components : {
        InternalMenu,
    },
    methods : {
        linkHasChildren( link ) {

            if( link.children === undefined ) { return false; }

            // hacky hacky hacky to remove the hümr results page
            if (link.slug == 'humr') {
                return false
            }

            if( typeof(link.children) === 'object' ) {
                let size = 0;
                let children = link.children;

                for( let c in children ) {
                    if( children[c] !== undefined) size++;
                }

                return size;
            }

            return false;
        },
        showSubmenu( e ) {
            e.target.classList.toggle('is-visible');
        }
    },
    computed : {
        linkCountClass() {
            return "has-" + Object.keys(this.links).length + "-items";
        },
        sortedLinks() {
            let sorted = Object.values(this.links);

            sorted.sort( (a, b) => {
                return a.menu_order - b.menu_order;
            });

            return sorted;
        }
    }
}
</script>